import type { SchedulePriceQuoteRequest } from "@b2bportal/lodging-cfar-api";
import { Product } from "@b2bportal/purchase-api";
import { ParentState } from "@checkout/types";
import type { State } from "xstate";
import type {
  HtsLodgingCfarQuotedProduct,
  PartialParentContextWithHtsLodgingCfar,
} from "./types";

type CfarUpdateStateType = State<PartialParentContextWithHtsLodgingCfar>;
export type CfarUpdateStateWithoutValue = Pick<CfarUpdateStateType, "context">;

export const getCfarCartUpdateRequest = (
  state: CfarUpdateStateWithoutValue
) => {
  const offerId = getCfarOfferId(state) ?? "";
  const params: SchedulePriceQuoteRequest = {
    offerId,
  };

  return params;
};

export const getCfarOfferId = (
  state: CfarUpdateStateType | CfarUpdateStateWithoutValue
) => state.context[ParentState.htsLodgingCfar].offerId;

export const getSelectedCfarOffer = (state: CfarUpdateStateWithoutValue) => {
  return state.context[ParentState.htsLodgingCfar]?.selectedOffer;
};

export const getQuotedCfarProduct = (state: CfarUpdateStateWithoutValue) => {
  return state.context[ParentState.cartQuote].quoteBreakdown?.products
    .map((x) => x.product)
    .find(
      (product): product is HtsLodgingCfarQuotedProduct =>
        product.type === Product.HtsLodgingCfar
    );
};
